import { render, staticRenderFns } from "./InfoMenu.vue?vue&type=template&id=0de67376&scoped=true"
import script from "./InfoMenu.vue?vue&type=script&lang=js"
export * from "./InfoMenu.vue?vue&type=script&lang=js"
import style0 from "./InfoMenu.vue?vue&type=style&index=0&id=0de67376&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0de67376",
  null
  
)

export default component.exports